<template>
    <section v-if="stay" class="sortie-medicale" aria-label="Sortie d’hospitalisation">
        <h3>Sortie d’hospitalisation</h3>
        <p>Chambre {{ stay.chambre }} · {{ stay.lit }}</p>
        <p v-if="stay.status === 'DISCHARGE_PLANNED'" class="sortie-validee">
            Sortie autorisée le {{ date(stay.discharge_planned_at) }} vers {{ stay.discharge_destination }}.
            L’infirmier confirmera le départ physique et le lit passera en nettoyage.
        </p>
        <template v-else>
            <label>Destination après la sortie
                <input v-model.trim="destination" type="text" maxlength="255" placeholder="Domicile, transfert…">
            </label>
            <button type="button" :disabled="saving || destination.length < 2" @click="approve">
                {{ saving ? 'Enregistrement…' : 'Autoriser la sortie' }}
            </button>
        </template>
        <p v-if="error" class="sortie-erreur" role="alert">{{ error }}</p>
    </section>
</template>

<script>
import stationApi from '@/api/consultations/_nursing-station'
import { parseBackendTimestamp } from '@/utils/backend-timestamp'

export default {
    name: 'sortie-hospitalisation',
    props: { consultationId: { type: Number, required: true } },
    data() { return { stay: null, destination: '', saving: false, error: '' } },
    watch: { consultationId() { this.load() } },
    mounted() { this.load() },
    methods: {
        date(value) {
            if (!value) return '—'
            const date = parseBackendTimestamp(value)
            return isNaN(date.getTime()) ? '—' : date.toLocaleString('fr-FR', { timeZone: this.getClinicTimezone() })
        },
        async load() {
            this.error = ''; this.stay = null
            if (!this.consultationId) return
            try {
                const result = await stationApi.stayForDoctor(this.consultationId)
                this.stay = result.data || null
            } catch (error) { this.error = 'Le séjour ne peut pas être chargé.' }
        },
        async approve() {
            if (!this.stay || this.saving || this.destination.length < 2) return
            if (!window.confirm('Confirmer la décision médicale de sortie ? L’infirmier validera ensuite le départ effectif.')) return
            this.saving = true; this.error = ''
            try {
                await stationApi.planDischarge(this.stay.id, this.destination)
                await this.load()
            } catch (error) { this.error = 'Sortie non autorisée. Vérifiez le séjour puis réessayez.' }
            finally { this.saving = false }
        }
    }
}
</script>

<style scoped lang="scss">
.sortie-medicale { margin: 20px 0; padding: 20px; border-radius: 14px; background: white; color: var(--ui-text, #344465); }
.sortie-medicale h3 { margin: 0 0 7px; font-size: 1.25rem; }
.sortie-medicale p { margin: 5px 0; }
.sortie-medicale label { display: block; margin: 16px 0 10px; font-weight: 600; }
.sortie-medicale input { display: block; width: 100%; max-width: 440px; box-sizing: border-box; margin-top: 5px; padding: 9px; border: 1px solid #b8c9e6; border-radius: 8px; }
.sortie-medicale button { padding: 9px 14px; border: 0; border-radius: 8px; background: #3b73f2; color: white; }
.sortie-medicale button:disabled { opacity: .55; }
.sortie-validee { color: #247954; }
.sortie-erreur { color: #a94945; }
</style>
